import { defineStore } from 'pinia'

export const useCategoryStore = defineStore('categories', {
    // a function that returns a fresh state
    state: () => ({
    }),
    // optional getters
    getters: {
    },
    // optional actions
    actions: {
        index(filter = {}) {
            return this.apiClientV2.get(`/categories`, {params: filter})
        },
    },
})
